const Roles = Object.freeze({
  WUNA_ADMIN: 'WUNA_ADMIN',
  ENTERPRISE_USER: 'ENTERPRISE_USER',
  THIRD_PARTY: 'THIRD_PARTY',
  VERIFIER: 'VERIFIER',
  END_USER: 'END_USER',
});

export default Roles;
